import { safeDefine } from "../../registration/safe-define.js";
import { TimeGroupElement } from "../../ui/time/group.js";
//#region src/define/ui/time-group.ts
safeDefine(TimeGroupElement);
//#endregion
